const ENIniciatives = {
	"Nenhuma ação encontrada": "No Actions Found",
	"Adicionar Ações": "Add Actions",
	"As ações vinculadas a iniciativa também serão excluídas": "Actions linked to the initiative will also be excluded",
	"Copiar": "Copy",
	"Copiar Iniciativas": "Copy Iniciatives",
	"Deseja realmente excluir a iniciativa": "Do you really want to delete the initiative",
	"Iniciativa atualizada com sucesso": "Successfully updated initiative",
	"Iniciativa Inserida com sucesso": "Initiative successfully inserted",
	"Iniciativa em edição": "Editing initiative",
	"Iniciativas ordenadas com sucesso": "Successfully ordered initiatives",
	"Iniciativas buscava com sucesso": "Initiatives successfully sought",
	"Iniciativa excluída com sucesso": "Initiative deleted successfully",
	"Editar Iniciativa": "Edit Iniciative",
	"Excluir Iniciativa": "Delete Initiative",
	"Exclusão da Iniciativa": "Exclusion from the Initiative",
	"É necessário inserir um titulo": "It is necessary to enter a title",
	"Erro ao atualizar a iniciativa": "Error updating initiative",
	"Erro ao adicionar iniciativa": "Error adding initiative",
	"Erro ao ordenar iniciativas": "Error ordering initiatives",
	"Erro ao buscar as iniciativas": "Error when searching for initiatives",
	"Erro ao excluir Iniciativa": "Error deleting initiative",
	"Nenhuma Iniciativa encontrada": "No Initiatives Found",
	"Nome da Iniciativa": "Initiative Name",
	"Nova Iniciativa": "New Initiative"
};

export default ENIniciatives;
